<template>
	<!-- 编辑商品机制 -->
	<el-dialog
		title="编辑商品机制"
		width="40%"
		:close-on-click-modal="false"
		class="edit-shop"
		:visible.sync="dialogEditShopVisible"
		@close="resetForms('EditShopFrom')"
		:append-to-body="true"
	>
		<p class="tips yx-color-text-primary fz-14" v-if="0">
			<i class="iconfont icon-a-warningjinggao-mian mr-6" style="color: #ed6a0c"></i>
			<span>系统通过商品信息采集链接更新商品的头图、标题、现售价，采集链接失效不影响商品的正常推广</span>
		</p>
		<div class="pl-12 pr-12 pt-12 pb-12 edit-shop-box mt-16 mb-16 flex">
			<div class="edit-shop-img">
				<img :src="EditShopFrom['product_pic']" alt="" />
			</div>
			<div class="ml-10 flex-column flex-just-between">
				<p class="yx-color-text-primary flex flex-align-center">
					<platform-icon :platformId="EditShopFrom.platform_id" class="mr-6"></platform-icon>{{ EditShopFrom['product_name'] }}
				</p>
				<p class="fz-12 yx-color-text-regular">商品ID：{{ EditShopFrom['third_product_id'] }}</p>
				<p class="yx-color-text-primary">现售价：¥{{ EditShopFrom['sale_price'] }}</p>
			</div>
		</div>
		<el-form :model="EditShopFrom" ref="EditShopFrom" :rules="EditShopRules">
			<el-form-item label="商品链接：" label-width="120px" prop="product_url">
				<el-input :disabled="true" v-model="EditShopFrom['product_url']" autocomplete="off" placeholder="请输入商品链接" type="textarea"></el-input>
			</el-form-item>
			<div class="flex">
				<el-form-item label="佣金率：" label-width="120px" prop="commission_rate">
					<el-input
						:disabled="EditShopFrom['source_type'] === '2'"
						v-model="EditShopFrom['commission_rate']"
						autocomplete="off"
						placeholder="请输入"
						suffix-icon="suffix-icon"
					></el-input>
				</el-form-item>
				<el-form-item label="直播价：" label-width="100px" prop="live_price">
					<el-input v-model="EditShopFrom['live_price']" autocomplete="off" placeholder="请输入"></el-input>
				</el-form-item>
				<el-form-item label="服务费：" label-width="100px" prop="service_rate">
					<el-input
						:disabled="EditShopFrom['source_type'] === '2'"
						v-model="EditShopFrom['service_rate']"
						autocomplete="off"
						placeholder="请输入"
						suffix-icon="suffix-icon"
					></el-input>
				</el-form-item>
			</div>
			<div class="flex">
				<el-form-item label="投放期佣金率：" label-width="120px" prop="commission_rate_during_the">
					<el-input
						v-model="EditShopFrom['commission_rate_during_the']"
						autocomplete="off"
						placeholder="请输入"
						suffix-icon="suffix-icon"
					></el-input>
				</el-form-item>
				<el-form-item label="投放期服务费率：" label-width="150px" prop="service_rate_during_the">
					<el-input
						v-model="EditShopFrom['service_rate_during_the']"
						autocomplete="off"
						placeholder="请输入"
						suffix-icon="suffix-icon"
					></el-input>
				</el-form-item>
			</div>
			<div style="margin-left: 40px" class="mb-16" v-if="sku_list.length">
				<p class="mb-16">申样规格： </p>
				<div class="view-sku">
					<el-table :data="sku_list" class="table" header-row-class-name="table-header-sku" row-class-name="table-row">
						<el-table-column label="商品规格" prop="name" align="center">
							<template v-slot="{ row }">
								<span class="fz-12">{{ row.specification | formatEmpty }}</span>
							</template>
						</el-table-column>
						<el-table-column label="规格ID" prop="price" align="center" width="100">
							<template v-slot="{ row }">
								<span class="fz-12">{{ row.outer_sku_id | formatEmpty }}</span>
							</template>
						</el-table-column>
						<el-table-column label="现售价" prop="price" align="center" width="100">
							<template v-slot="{ row }">
								<span class="fz-12">{{ row.price | formatEmpty | formatPrice }}</span>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
			<el-form-item label="规格：" label-width="120px" prop="spec" v-else>
				<el-input
					v-model="EditShopFrom['spec']"
					autocomplete="off"
					type="textarea"
					placeholder="规格一、规格二、规格三…"
					maxlength="255"
					show-word-limit
				></el-input>
			</el-form-item>
			<el-form-item label="赠品：" label-width="120px">
				<el-input
					v-model="EditShopFrom['gifts']"
					autocomplete="off"
					type="textarea"
					placeholder="请输入赠品"
					maxlength="80"
					show-word-limit
				></el-input>
			</el-form-item>
			<el-form-item label="发货地点：" label-width="120px">
				<el-input
					v-model="EditShopFrom['delivery_site']"
					autocomplete="off"
					placeholder="请输入发货地点，如浙江义乌"
					maxlength="20"
					show-word-limit
				></el-input>
			</el-form-item>
			<div class="flex flex-just-between">
				<el-form-item label="发货时间：" label-width="120px">
					<el-input v-model="EditShopFrom['delivery_time']" autocomplete="off" placeholder="请输入发货时间" maxlength="10" show-word-limit></el-input>
				</el-form-item>
				<el-form-item label="发货快递：" label-width="120px">
					<el-input
						v-model="EditShopFrom['delivery_courier']"
						autocomplete="off"
						placeholder="请输入发货快递"
						maxlength="10"
						show-word-limit
					></el-input>
				</el-form-item>
			</div>
			<el-form-item label="不发货地区：" label-width="120px">
				<el-input
					v-model="EditShopFrom['delivery_site_no']"
					type="textarea"
					autocomplete="off"
					:autosize="{ minRows: 2.5, maxRows: 4 }"
					placeholder="请输入不发货地区"
					maxlength="1000"
				></el-input>
			</el-form-item>
			<el-form-item label="商品卖点：" label-width="120px" prop="selling_points">
				<el-input
					v-model="EditShopFrom['selling_points']"
					type="textarea"
					autocomplete="off"
					:autosize="{ minRows: 2.5, maxRows: 4 }"
					placeholder="请输入商品卖点"
				></el-input>
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button @click="dialogEditShopVisible = false">取消</el-button>
			<el-button type="primary" @click="editShopConfirm">确认</el-button>
		</div>
	</el-dialog>
</template>
<script>
import { shopDetail, editProduct, syncProductSkuList } from '@/api/shopManage';
import { checkPriceReg } from '@/utils/validate';
export default {
	name: 'editShopDialog',
	data() {
		return {
			dialogEditShopVisible: false,
			EditShopFrom: {
				commission_rate_during_the: '',
				service_rate_during_the: '',
			},
			EditShopRules: {
				commission_rate: [{ required: true, message: '请输入佣金率', trigger: 'blur' }],
				live_price: [{ required: true, validator: checkPriceReg, trigger: 'blur' }],
				service_rate: [{ required: true, message: '请输入服务费', trigger: 'blur' }],
				spec: [{ required: true, message: '请输入规格', trigger: 'blur' }],
			},
			sku_list: [],
		};
	},
	components: {},
	props: {},
	methods: {
		//编辑商品机制
		async editShop(row) {
			await this.asyncSkuList(row);
			let params = {
				product_id: row.product_id,
			};

			const { code, data } = await shopDetail(params);
			if (code == 0) {
				this.EditShopFrom = data;
				this.sku_list = data.sku_list || [];
				this.dialogEditShopVisible = true;
			}
		},
		//上传商品机制
		editShopConfirm() {
			// this.dialogReconfirmCardVisible = true
			// return;
			this.$refs['EditShopFrom'].validate(async valid => {
				if (valid) {
					let newObj = JSON.parse(JSON.stringify(this.EditShopFrom));
					for (var key in newObj) {
						if (key == 'commission_rate' || key == 'service_rate') {
							newObj[key] = newObj[key] + '%';
						}
					}
					const { code } = await editProduct(newObj);
					if (code == 0) {
						this.$message.success('编辑成功');
						this.dialogEditShopVisible = false;
						this.$emit('refreshList');
					}
				}
			});
		},
		//重置弹框表单
		resetForms(from) {
			this.$refs[from].resetFields();
		},
		async asyncSkuList(row) {
			// 同步商品sku， 抖音更改了同步sku的限额，所以只能按需同步，使用哪个商品就调用同步哪个sku
			await syncProductSkuList({
				platformId: row.platform_id,
				productIds: [
					{
						outProductId: row.third_product_id,
						productId: row.product_id,
					},
				],
				source: dataMap.syncSkuSource.edit_product,
			});
		},
	},
};
</script>
<style lang="less" scoped>
.edit-shop {
	/deep/ .el-dialog__body {
		padding-top: 0px;
	}
	/deep/ .suffix-icon::after {
		content: '%';
		width: 33px;
		background-color: #f7f8fa;
		border-bottom-right-radius: 2px;
		border-top-right-radius: 2px;
	}
	/deep/ .el-input__suffix {
		height: 92%;
		right: 1px;
		top: -1px;
	}
}
.edit-shop-box {
	background-color: #f8f8f8;
	border-radius: 2px;
}
.edit-shop-img {
	width: 64px;
	height: 64px;
}
.tips {
	padding: 8px 12px;
	background-color: #fff5ed;
	border: 1px solid #f1924e;
}
.view-sku {
	background-color: #f7f8fa;
	border: 1px solid #f0f1f5;
	border-bottom: none;
	border-radius: 8px;
	/deep/ .el-table__body-wrapper {
		height: 172px;
		overflow-y: auto;
		&::-webkit-scrollbar {
			width: 6px;
		}
		&::-webkit-scrollbar-thumb {
			height: 26px;
			border-radius: 3px;
			background-color: @border-color-lighter;
		}
	}
	::v-deep .table-header-sku th {
		border-bottom: 1px solid #f0f1f5 !important;
	}
}
</style>
